var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgUserDue = function SvgUserDue(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.25 3H2.75A2.752 2.752 0 0 0 0 5.75v12.5A2.752 2.752 0 0 0 2.75 21h18.5A2.752 2.752 0 0 0 24 18.25V5.75A2.752 2.752 0 0 0 21.25 3zM7.5 7C8.878 7 10 8.122 10 9.5S8.878 12 7.5 12 5 10.878 5 9.5 6.122 7 7.5 7zm4.5 9.25a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75v-.5A2.752 2.752 0 0 1 5.75 13h3.5A2.752 2.752 0 0 1 12 15.75zm8.25.75h-5.5a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 1 0 1.5zm0-4h-5.5a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 1 0 1.5zm0-4h-5.5a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 1 0 1.5z",
    opacity: 1,
    "data-original": "#000000"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserDue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/userDue.a7c6c6f6.svg";
export { ForwardRef as ReactComponent };